/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsReferences,
    SharedserviceMelcoModelsReferencesFromJSON,
    SharedserviceMelcoModelsReferencesFromJSONTyped,
    SharedserviceMelcoModelsReferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsImageReferences
 */
export interface SharedserviceMelcoModelsImageReferences {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsImageReferences
     */
    blank_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsImageReferences
     */
    custom_product_list?: Array<SharedserviceMelcoModelsReferences> | null;
}

export function SharedserviceMelcoModelsImageReferencesFromJSON(json: any): SharedserviceMelcoModelsImageReferences {
    return SharedserviceMelcoModelsImageReferencesFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsImageReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsImageReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'blank_list': !exists(json, 'blank_list') ? undefined : (json['blank_list'] === null ? null : (json['blank_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'custom_product_list': !exists(json, 'custom_product_list') ? undefined : (json['custom_product_list'] === null ? null : (json['custom_product_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
    };
}

export function SharedserviceMelcoModelsImageReferencesToJSON(value?: SharedserviceMelcoModelsImageReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'blank_list': value.blank_list === undefined ? undefined : (value.blank_list === null ? null : (value.blank_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'custom_product_list': value.custom_product_list === undefined ? undefined : (value.custom_product_list === null ? null : (value.custom_product_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
    };
}


